import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios, { AxiosResponse } from 'axios';
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { baseURL, headers } from '../../../redux/helpersRedux';
import {numerosNaturales} from '../../../Utils/regex';
import { CLIENTE, CLIENTE_DIRECCION_PROFORMA, CIUDAD} from '@pcgerente-node/pcg-comun/dist/DTOs';
import '../../../styles/misDestinatarios.css'

interface ChildProps {
  cliente: CLIENTE,
  ciudades: CIUDAD[]
}

const ModalCrearAgencia: React.FC<ChildProps> = ({ cliente, ciudades }) => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  
  const [infoToSubmit, setInfoToSubmit] = useState(new CLIENTE_DIRECCION_PROFORMA())

  const handleInfo = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>, type: string) => {
    
    if (type === "ciudad") {
      const Filtered = ciudades.find(ciudad => ciudad.id === Number(e.target.value))
      if (Filtered?.id) {
        setInfoToSubmit({
          ...infoToSubmit,
          idCiudad: Filtered.id,
        })
      }
    }
    
    if (type === "descripcion") {
      setInfoToSubmit({
        ...infoToSubmit,
        descripcion: e.target.value
      })
    }

    if (type === "direccion") {
      setInfoToSubmit({
        ...infoToSubmit,
        direccion: e.target.value
      })
    }

    if (type === "telefono1" || type === "telefono2" || type === "telefono3") {
      const current = type
      if (e.target.value.length <= 10 && (numerosNaturales(e.target.value) || e.target.value === "")) {
        setInfoToSubmit({
          ...infoToSubmit,
          [current]: e.target.value
        })
      }
    }

    if (type === "establecimiento" && (numerosNaturales(e.target.value) || e.target.value === "")) {
      setInfoToSubmit({
        ...infoToSubmit,
        establecimiento: e.target.value
      })
    }
    setMensajeSubmit("")
  }

  const handleSubmit = async () => {
    let mensajeError = ""

    if(!infoToSubmit.direccion){
      mensajeError = "Error: Necesita ingresar una dirección"
    }
    else if(!infoToSubmit.descripcion){
      mensajeError = "Error: Necesita ingresar una descripción"
    }
    else if(!infoToSubmit.idCliente){
      mensajeError = "Error: No se encuentra el cliente"
    }
    else if(!infoToSubmit.idCiudad){
      mensajeError = "Error: Necesita asignar una ciudad a este establecimiento"
    }
    else if(!infoToSubmit.establecimiento){
      mensajeError = "Error: Necesita asignar un numero a este establecimiento"
    }
    else if(!infoToSubmit.telefono1){
      mensajeError = "Error: Necesita asignar al menos un número de teléfono a este establecimiento"
    }


    if (mensajeError.length === 0) {
      const response = await axios.post(`${baseURL}CLIENTE/${infoToSubmit.idCliente}/CLIENTE_DIRECCION_PROFORMA`, infoToSubmit, headers)
      .then((res:AxiosResponse<IApiResponse<CLIENTE_DIRECCION_PROFORMA>>) =>res.data)
      if(response.companion?.id && response.error === undefined){
        setMensajeSubmit("Se ha creado un nuevo establecimiento")
        if (cliente.id){
          setInfoToSubmit(new CLIENTE_DIRECCION_PROFORMA())
        }
      }else{
        setMensajeSubmit(`Error: ${response.error} `)
      }
    } else{
      setMensajeSubmit(mensajeError)    
    }

  }
  

  const handleClick = () => {
    handleShow()
    if(cliente.id){
      setInfoToSubmit({
        ...infoToSubmit,
        idCliente: cliente.id
      })
    }
  }

  const [mensajeSubmit, setMensajeSubmit] = useState("")
  return (
    <>
      <button className='btn-verAgencias-misDestinatarios'
        onClick={() => handleClick()}
      >
        Crear Agencia
      </button>

      <Modal show={show}
        onHide={handleClose}
        centered
        animation={false}
      >
        <Modal.Header>
          <Modal.Title>{cliente.razonSocial}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={(e) => e.preventDefault()} className='d-flex flex-column'>
            <div className='d-flex flex-column'>
              <label>Ingrese la dirección del establecimiento</label>
              <input
                type="text"
                placeholder='Direccion'
                className={`inputTextModal`}
                onChange={(e) => handleInfo(e, "direccion")}
                value={infoToSubmit.direccion}
              />
            </div>
            <div className='d-flex flex-column'>
              <label>Ingrese la descripción del establecimiento</label>
              <input
                type="text"
                placeholder='Descripción'
                className={`inputTextModal`}
                onChange={(e) => handleInfo(e, "descripcion")}
                value={infoToSubmit.descripcion}
              />
            </div>

            <div className='d-flex justify-content-between'>
              <div className='d-flex flex-column  justify-content-center '>
                <label>Ingrese los números de teléfono del establecimiento </label>
                <input
                  type="text"
                  className={`inputTextModal ml-2`}
                  name="telefono1"
                  placeholder='*telefono 1'
                  onChange={(e) => handleInfo(e, "telefono1")}
                  value={infoToSubmit.telefono1 || ""}
                />
                <input
                  type="text"
                  className={`inputTextModal ml-2`}
                  name="telefono2"
                  placeholder='telefono 2'
                  onChange={(e) => handleInfo(e, "telefono2")}
                  value={infoToSubmit.telefono2 || ""}
                />
                <input
                  type="text"
                  className={`inputTextModal ml-2`}
                  name="telefono3"
                  placeholder='telefono 3'
                  onChange={(e) => handleInfo(e, "telefono3")}
                  value={infoToSubmit.telefono3 || ""}
                />
              </div>
              <div className='d-flex ml-4' >
                <div className='d-flex flex-column justify-content-center '>
                <div className='flex-column align-items-center'>
                  <label>Seleccione la ciudad del establecimiento</label>
                  <select name="country_code"
                    onChange={(e) => handleInfo(e, "ciudad")}
                    color="white"
                    className={`selectCiudad`}
                    value={infoToSubmit.idCiudad}
                  >
                    <option value="0" hidden>--Ciudad--</option>
                    {ciudades?.map(ciudad => {
                      return <option key={ciudad.id} value={ciudad.id}>
                        {ciudad.nombre}
                      </option>
                    })}
                  </select>
                </div>
                <div className='d-flex flex-column'>
                  <label>Numero del establecimiento</label>
                  <input
                    type="text"
                    className= "inputTextModal inputNumeroResponsiveModal"
                    name="establecimiento"
                    value={infoToSubmit.establecimiento}
                    onChange={(e) => handleInfo(e, "establecimiento")}
                  /> 
                </div>
              </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-100 justify-content-between'>
            <span 
              className={`${mensajeSubmit.includes("Error")? "text-danger": "text-success"}`}
              style={{marginBottom: "0px", fontSize: "1.1rem"}}      
            >
              {mensajeSubmit}
            </span>
            <div className='d-flex justify-content-center align-items-center'>
              <button className='btn btn-danger mr-2' onClick={() => handleClose()}>Cancelar</button>
              <button className='btn btn-primary' onClick={() => handleSubmit()}>Crear</button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCrearAgencia;